<template lang="pug">
div
  div(slot="body" v-if="cadastroOriginal.tipoReurbIndividual")
    el-row(v-if="isPessoaJuridicaReurb", :span="24")
      el-col(:span="12")
        app-display(
          id="TIPO_REURB",
          label="Tipo de Reurb:",
          :content="formataTipoReurb(cadastroOriginal.tipoReurbIndividual)"
        )
      el-col(:span="12")
        app-display(
          id="TIPO_REQUERENTE",
          label="Tipo requerente:",
          :content="formatarTexto(cadastroOriginal.tipoRequerente)"
        )

    div(v-if="!isPessoaFisica && isPessoaJuridicaReurb && isTipoRequerentePj", slot="body")
      app-divider(label="Dados Requerente")
      el-row(v-if="isPessoaJuridicaReurb", :span="24")
        el-col(:span="12")
          app-display(
            id="CNPJ",
            label="CNPJ:",
            :content="cadastroOriginal.cnpjRequerente"
          )
        el-col(:span="12")
          app-display(
            id="RAZAO_SOCIAL",
            label="Razão social:",
            :content="cadastroOriginal.razaoSocialRequerente"
          )
  div(v-if="!cadastroOriginal.tipoReurbIndividual && isReurb && isPessoaJuridicaReurb")
    el-col
      app-display(
        :content="'Não foi informado nenhum dado durante o cadastro.'"
      )
  app-divider(label="Dados Interessado" v-if="isReurb && !isPessoaJuridicaReurb")
  informacoes-pessoa( v-if="!isPessoaJuridicaReurb"
    :pessoa="interessado.pessoa",
    :razaoSocialName="isOnerosoGroup ? 'Razão Social:' : 'Associação/Comunidade:'"
    :rendaFamiliar="interessado.rendaFamiliar",
    :membroFamilia="membroInteressadoPorNome"
    :compararInformacoesPessoa = "compararInteressado && compararInteressado.mudouPessoa"
    :isProcessoFisico="isProcessoFisico"
    :isReurb="isReurb"
    :isBancoDados="isBancoDados"
    :cnpjRequerente="cadastroOriginal.cnpjRequerente"
    :razaoSocialRequerente="cadastroOriginal.razaoSocialRequerente"
  )

  app-collapse(:title="labelSocioRepresentante.titleSocioRepresentante" v-if="interessado.sociosRepresentantesLegais && interessado.sociosRepresentantesLegais.length > 0 && !isPessoaJuridicaReurb")
    app-collapse-child(v-for="(socio, index) in interessado.sociosRepresentantesLegais" :title="socio.pessoa.pessoaFisica.nome", :key="socio.id")
      informacoes-pessoa(
        :pessoa="socio",
        :isSocio="true",
        :isSocioRepresentanteLegal="true",
        :razaoSocialName="isOnerosoGroup ? 'Razão Social:' : 'Associação/Comunidade:'"
        :compararInformacoesPessoa = "compararInteressado && compararInteressado.mudouSocioRepresentanteLegal  "
        :compararIsSocioRepresentanteLegal = "compararInteressado && compararInteressado.mudouSocioRepresentanteLegal"
        :cnpjRequerente="cadastroOriginal.cnpjRequerente"
        :razaoSocialRequerente="cadastroOriginal.razaoSocialRequerente"
      )
      listagem-documentos(
        v-if="socio.documentos && socio.documentos.length > 0"
        :documentos="socio.documentos",
        :protocoloCadastroOriginal="cadastroOriginal.protocolo",
        ownerDocumento="SOCIO_REPRESENTANTE",
        :idSocio="socio._id || socio.id"
        :compararDocumentos = "compararInteressado && compararInteressado.mudouDocumentosInteressado"
        :versaoCadastro = "versaoCadastro"
      )

  app-divider(label="Endereço" v-if="!isReurb && !isProcessoFisico && !isBancoDados")
    informacoes-endereco.margin-top(:endereco="enderecoInteressado", slot="body", :mudouEndereco = "compararInteressado && compararInteressado.mudouEndereco")
  app-divider(v-if="hasConjuge && !isPessoaJuridicaReurb && hasConjugeVersionsCadastro" label="Cônjuge")
    informacoes-pessoa.margin-top(
      slot="body",
      :pessoa="interessado.conjuge.pessoa || interessado.conjuge || interessado.conjuge.pessoaFisica",
      :isConjuge="hasConjuge",
      :razaoSocialName="isOnerosoGroup ? 'Razão Social:' : 'Associação/Comunidade:'"
      v-if="!isViuvo"
      :compararInformacoesPessoa = "compararInteressado && compararInteressado.mudouConjugeInteressado"
      :isProcessoFisico="isProcessoFisico"
      :isReurb="isReurb",
      :membroFamilia="membroConjugePorNome"
      :isBancoDados="isBancoDados"
      :cnpjRequerente="cadastroOriginal.cnpjRequerente"
      :razaoSocialRequerente="cadastroOriginal.razaoSocialRequerente"
    )
    div(v-else-if="hasDadosConjugeInteressadoViuvo", slot="body")
      app-display(
        id="NOME_VIUVO",
        label="Nome:",
        :content="conjuge.pessoaFisica.nome || '-'",
        :class = "compararInteressado && compararInteressado.mudouPessoa.mudouNome ? 'text': '' "
      )
      app-display(
        id="DATA_OBITO_CONJUGE",
        label="Data de óbito:",
        :content="this.formatDate(conjuge.pessoaFisica.dataObito) || '-'"
        :class = "'text'"
      )
      app-display(
        id="CPF_VIUVO",
        label="CPF:",
        :content="conjuge.pessoaFisica.cpf || '-'"
        :class = "compararInteressado && compararInteressado.mudouPessoa.mudouCPF ? 'text': '' "
      )
  app-divider(v-else-if="!isReurb", label="Cônjuge")
    div.margin-top(slot="body")
      app-display(
        id="POSSUI_CONJUGE",
        label="Possui cônjuge?"
        content="Não"
        :class = "compararInteressado && compararInteressado.mudouPossuiConjugeInteressado ? 'text': '' "
      )
  app-divider(v-else-if="!isPessoaJuridicaReurb && !hasConjugeVersionsCadastro && isReurb", label="Cônjuge")
    div.margin-top(slot="body")
      app-display(
        id="POSSUI_CONJUGE",
        content="Não foi informado nenhum dado durante o cadastro."
        :class = "compararInteressado && compararInteressado.mudouPossuiConjugeInteressado ? 'text': '' "
      )
  app-divider(v-else label="Cônjuge")
    div.margin-top(slot="body")
      app-display(
        id="POSSUI_CONJUGE",
        content="Não foi informado nenhum dado durante o cadastro."
      )
  app-divider(v-if="hasFamilia && !isPessoaJuridicaReurb" label="Membros da família" :class="compararInteressado.mudouMembroFamilia ? 'text' : 'titulo' ")
  div
    app-membro-familia(v-if="membrosNotInteressadoAndConjuge && membrosNotInteressadoAndConjuge.length > 0 && !isPessoaJuridicaReurb" :membros="membrosNotInteressadoAndConjuge", :appMembroFamiliaComparar = "compararInteressado && compararInteressado.mudouMembroFamilia")
    div.margin-top(slot="body" v-if="membrosNotInteressadoAndConjuge && membrosNotInteressadoAndConjuge.length === 0 && !isPessoaJuridicaReurb")
      app-display(
        id="POSSUI_MEMBRO_FAMILIA",
        content="Não foi informado nenhum dado durante o cadastro."
      )
</template>

<script>
import AppDisplayColapse from '@/components/AppDisplayColapse'
import AppDivider from '@/components/AppDivider.vue'
import InformacoesEndereco from '@/components/informacoesCadastro/ma/InformacoesEndereco'
import InformacoesPessoa from '.././ma/InformacoesPessoa'
import AppDisplay from '@/components/AppDisplay'
import ListagemDocumentos from '.././ListagemDocumentos'
import AppCollapse from '@/components/AppCollapse'
import AppMembroFamilia from '@/components/AppMembroFamiliaComparar'
import AppCollapseChild from '@/components/AppCollapseChild'
import compararReticacoesDefault from '../../../utils/pa/compararReticacoesDefault'
import moment from 'moment'
const { labelVisualizacaoProcesso, tiposProcessoFisico } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  props: {
    cadastroOriginal: {
      type: Object,
      required: true
    },
    isOnerosoGroup: {
      type: Boolean,
      required: true
    },
    isReurb: {
      type: Boolean,
      required: false
    },
    isBancoDados: {
      type: Boolean,
      required: false,
      default: false
    },
    interessado: {
      type: Object,
      required: true
    },
    compararInteressado: {
      type: Object,
      default: compararReticacoesDefault.mudouInteressadoDTODefault
    },
    versaoCadastro: {
      type: String,
      default: 'MAX(versao_json)'
    },
    isPessoaJuridicaReurb: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    InformacoesEndereco,
    AppDisplayColapse,
    InformacoesPessoa,
    ListagemDocumentos,
    AppDivider,
    AppDisplay,
    AppCollapse,
    AppCollapseChild,
    AppMembroFamilia
  },
  data () {
    return {
      colapses: ['1'],
      labelSocioRepresentante: labelVisualizacaoProcesso.etapaInteressado,
      tiposProcessoFisico
    }
  },
  created () {
    if (!this.isBancoDados) {
      this.mergePessoaFisicaMebroFamilia()
    }
  },
  computed: {
    isProcessoFisico () {
      return this.tiposProcessoFisico.includes(this.cadastroOriginal.tipo)
    },
    enderecoInteressado () {
      return this.interessado.pessoa.endereco ? this.interessado.pessoa.endereco : {}
    },
    enderecoCorrespondencia () {
      return this.interessado.pessoa.enderecoCorrespondencia ? this.interessado.pessoa.enderecoCorrespondencia : {}
    },
    hasConjuge () {
      if (this.isProcessoFisico) {
        return this.interessado.conjuge?.pessoaFisica?.cpf
      }
      if (this.isViuvo) {
        return this.hasDadosConjugeInteressadoViuvo
      }
      return (this.interessado.pessoa.pessoaFisica || this.interessado.pessoa.pessoaJuridica?.representanteLegal) && !(!this.interessado.conjuge)
    },
    hasFamilia () {
      return (this.interessado.pessoa.pessoaFisica || this.interessado.pessoa.pessoaJuridica?.representanteLegal) && !(!this.interessado?.membrosFamilia)
    },
    isViuvo () {
      if (!this.interessado.pessoa.pessoaFisica) {
        return false
      }
      return this.interessado.pessoa?.pessoaFisica?.estadoCivil === 'VIUVO'
    },
    conjuge () {
      return this.interessado.conjuge?.pessoa ? this.interessado.conjuge?.pessoa : this.interessado?.conjuge
    },
    isInteressadoPj () {
      return ['PJ', 'PESSOA_JURIDICA'].includes(this.interessado?.pessoa?.tipo)
    },
    nomeInteressadoParaMembro () {
      if (this.isInteressadoPj) {
        return this.interessado?.pessoa?.pessoaJuridica?.representanteLegal?.nome
      }
      return this.interessado?.pessoa?.pessoaFisica?.nome
    },
    membroInteressadoPorNome () {
      return this.interessado.membrosFamilia && this.interessado.membrosFamilia.find(membro => membro.nome === this.nomeInteressadoParaMembro)
    },
    membroConjugePorNome () {
      return this.interessado.membrosFamilia && this.interessado.membrosFamilia.find(membro => membro.nome === this?.interessado?.conjuge?.pessoaFisica?.nome)
    },
    membrosNotInteressadoAndConjuge () {
      return this.interessado.membrosFamilia && this.interessado.membrosFamilia.filter(membro => membro.nome !== this.nomeInteressadoParaMembro && membro.nome !== this?.interessado?.conjuge?.pessoaFisica?.nome)
    },
    isPessoaFisica () {
      return this.cadastroOriginal.tipoRequerente === 'PESSOA_FISICA'
    },
    hasConjugeVersionsCadastro () {
      if (this.isReurb) {
        return this.interessado.possuiConjuge
      }
      return true
    },
    isTipoRequerentePj () {
      return ['PESSOA_JURIDICA', 'PJ'].includes(this.cadastroOriginal.tipoRequerente)
    },
    hasDadosConjugeInteressadoViuvo () {
      return this.isViuvo && (this.conjuge?.pessoaFisica?.nome || this.conjuge?.pessoaFisica?.dataObito || this.conjuge?.pessoaFisica?.cpf)
    }
  },
  methods: {
    formatarTexto (texto) {
      if (['PESSOA_FISICA', 'PF'].includes(texto)) {
        return 'Pessoa física'
      } else if (['PESSOA_JURIDICA', 'PJ'].includes(texto)) {
        return 'Pessoa jurídica'
      }
      return '-'
    },
    formataTipoReurb (tipo) {
      if (['REURB_S', 'REURB_E'].includes(tipo)) {
        return tipo.replace('_', ' ')
      }
      return '-'
    },
    formatDate (date) {
      if (!date) {
        return '-'
      }
      const formatedDate = moment(date).format('DD/MM/YYYY')
      return formatedDate !== 'Invalid date' ? formatedDate : '-'
    },
    mergePessoaFisicaMebroFamilia () {
      if (!this.interessado?.membrosFamilia?.length) {
        return
      }
      if (!['PF', 'PESSOA_FISICA'].includes(this.interessado?.pessoa?.tipo)) {
        if (this.interessado.possuiConjuge) {
          this.interessado.conjuge.pessoaFisica = {
            ...this.interessado.conjuge.pessoaFisica,
            ...this.interessado.membrosFamilia[1]
          }
        }
        return
      }
      this.interessado.pessoa.pessoaFisica = {
        ...this.interessado.pessoa.pessoaFisica,
        ...this.interessado.membrosFamilia[0]
      }
      if (this.interessado.possuiConjuge) {
        this.interessado.conjuge.pessoaFisica = {
          ...this.interessado.conjuge.pessoaFisica,
          ...this.interessado.membrosFamilia[1]
        }
      }
    }
  },
  watch: {
    interessado: {
      handler (val) {
        this.mergePessoaFisicaMebroFamilia()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.margin-top {
  margin-top: 10px;
}

@media (max-width: 780px) {
  .margin-top {
    display: flex;
    flex-direction: column;
    width: 490px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/ma/InformacoesInteressado.vue